import styled from "styled-components";

export const Styles = styled.div`
    .loader-container {
        position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    z-index: 9;

        .loader {
            left: 50%;
    top: 50%;
    z-index: 99999;
    position: absolute;
    transform: translate(-50%, -50%);
        }
    }
`;